import React from "react";
import Page from "components/Page";
import { Props } from "./SiteStatusCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const SiteStatusCustomTypes = lazyWithRetry(() =>
  import("./SiteStatusCustomTypes")
);

export default (props: Props) => (
  <Page>
    <SiteStatusCustomTypes {...props} />
  </Page>
);
